import axios from 'axios';
import { getToken, getTokenHeader } from '../../../../../screen/auth/action';
import { StaffInsuranceBeneficiaryUrl, StaffInsurancesUrl, StaffInsurancesNomineeUrl, AdhaarOCRVerificationUrl, PanOCRVerificationUrl } from '../url';

export const getStaffInsuranceAction  = async (company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${StaffInsurancesUrl()}?company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const AddStaffBeneficiaryAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${StaffInsuranceBeneficiaryUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const AddStaffNomineeAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${StaffInsurancesNomineeUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const deleteStaffAction = async (is_beneficiary, is_nominee, staff_no, company_esi_id) => {
  try {
    const token = await getToken();
    const { data } = await axios.delete(
      `${StaffInsurancesUrl()}?staff_id=${staff_no}&is_nominee=${is_nominee}&is_beneficiary=${is_beneficiary}&company_esi_id=${company_esi_id}`,
      getTokenHeader(token)
    );
    return data;
  } catch (err) {
    return { error: err };
  }
};

export const AdhaarOCRVerficiationAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${AdhaarOCRVerificationUrl()}`,
        data,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          }
        }
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: true, message: err?.response?.data?.message || err?.message || 'OCR processing failed' });
      });
  });
};

export const PanOCRVerificationAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${PanOCRVerificationUrl()}`,
        data,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          }
        }
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: true, message: err?.response?.data?.message || err?.message || 'OCR processing failed' });
      });
  });
};